import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { defaultPdfTronElements, SeparatorButton, PdfTronElement, pdfTronElementsToDisable, AnnotatableFileMimeType, AlertLocation, AlertType, cogMenu, thumbnailElements, leftPanelElements, annotationsFeatureWebViewerElements, freeTextToolElements, highlightToolElements, tickMarkToolElements } from './dms-viewer-interface';
import { CustomButton, MenuItemType, CustomButtonBase64PngImage } from './dms-viewer-configuration-constants';
import { saveAs } from 'file-saver';
import { DiContainer } from '@onviobr/toolbox-document-services/dist/esm5';
import { registerRubberStampTool } from './custom-viewer-tools/rubber-stamp-tool';
import { PdfTronFeature } from '@onviobr/toolbox-file-viewer';
function hasTool(webViewer, toolName) {
  var hasTool = false;
  webViewer.UI.setHeaderItems(function (header) {
    hasTool = header.getItems().some(function (item) {
      return item.toolName === toolName;
    });
  });
  return hasTool;
}
function addFreeTextGroupTool(webViewer) {
  var divider;
  var toolsOverlay;
  webViewer.UI.setHeaderItems(function (header) {
    var headerButtons = header.getHeader(PdfTronElement.toolbarGroupAnnotate).getItems();
    divider = headerButtons.find(function (x) {
      return x.type === SeparatorButton.divider;
    });
  });
  if (hasTool(webViewer, CustomButton.FreeTextGroupTool)) {
    webViewer.UI.setHeaderItems(function (header) {
      header.getHeader('default').get(PdfTronElement.freeTextToolGroupButton).insertAfter(divider);
    });
    return;
  }
  webViewer.UI.setHeaderItems(function (header) {
    var headerButtons = header.getHeader(PdfTronElement.toolbarGroupAnnotate).getItems();
    divider = headerButtons.find(function (x) {
      return x.type === SeparatorButton.divider;
    });
    toolsOverlay = header.getHeader(PdfTronElement.toolbarGroupAnnotate).get(PdfTronElement.toolsOverlay);
    header.delete(PdfTronElement.toolsOverlay);
  });
  webViewer.UI.setHeaderItems(function (header) {
    var freeTextGroup = {
      type: 'toolGroupButton',
      toolGroup: 'freeTextTools',
      dataElement: PdfTronElement.freeTextToolGroupButton,
      title: 'annotation.freetext',
      toolName: CustomButton.FreeTextGroupTool
    };
    header.getHeader('default').get(CustomButton.TickMarkYellow).insertAfter(freeTextGroup);
    header.getHeader('default').get(PdfTronElement.freeTextToolGroupButton).insertAfter(divider);
  });
  webViewer.UI.setHeaderItems(function (header) {
    var headerButtons = header.getItems();
    var dividerIndex = headerButtons.findIndex(function (x) {
      return x.type === SeparatorButton.divider;
    });
    headerButtons.splice(dividerIndex + 1, 0, toolsOverlay);
    header.update(headerButtons);
  });
}
function addHighlightGroupTool(webViewer) {
  if (hasTool(webViewer, CustomButton.HighlightGroupTool)) {
    return;
  }
  webViewer.UI.setHeaderItems(function (header) {
    var highlightGroup = {
      type: 'toolGroupButton',
      toolGroup: 'highlightTools',
      dataElement: PdfTronElement.highlightToolGroupButton,
      title: 'annotation.highlight',
      toolName: CustomButton.HighlightGroupTool
    };
    header.getHeader('default').get(PdfTronElement.freeTextToolGroupButton).insertBefore(highlightGroup);
  });
}
function addTickMarkTools(webViewer, toolName, iconData) {
  if (hasTool(webViewer, toolName)) {
    webViewer.UI.enableTools([toolName]);
    return;
  }
  registerRubberStampTool(webViewer, toolName, iconData);
  webViewer.UI.setHeaderItems(function (header) {
    header.getHeader('default').get('selectToolButton').insertAfter({
      type: MenuItemType.ToolButton,
      toolName: toolName,
      img: iconData
    });
  });
  webViewer.UI.contextMenuPopup.add([{
    type: MenuItemType.ToolButton,
    toolName: toolName
  }]);
}
function removeHeaderSeparatorItems(webViewer) {
  webViewer.UI.setHeaderItems(function (header) {
    var headerButtons = header.getItems();
    var visibleHeaderButtons = headerButtons.filter(function (x) {
      return x.type !== SeparatorButton.divider;
    });
    var allHeaderButtons = _toConsumableArray(visibleHeaderButtons);
    header.update(allHeaderButtons);
  });
}
function enableElements(webViewer, options) {
  var _options$additionalPd;
  var defaultElements = options.disableDefaultPdfTronElements ? [] : defaultPdfTronElements;
  webViewer.UI.enableElements([].concat(_toConsumableArray(defaultElements), _toConsumableArray((_options$additionalPd = options.additionalPdfTronElements) !== null && _options$additionalPd !== void 0 ? _options$additionalPd : [])));
}
function disableElements(webViewer) {
  webViewer.UI.disableElements(pdfTronElementsToDisable);
  webViewer.UI.closeElements([PdfTronElement.printModal]);
}
function setReadOnly(webViewer, readonly) {
  var annotationsManager = webViewer.Core.documentViewer.getAnnotationManager();
  if (annotationsManager) {
    if (readonly) annotationsManager.enableReadOnlyMode();else annotationsManager.disableReadOnlyMode();
  }
}
export function configureWebViewer(_x, _x2) {
  return _configureWebViewer.apply(this, arguments);
}
function _configureWebViewer() {
  _configureWebViewer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(webViewer, options) {
    var webViewerElements, _options$additionalPd2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (options.enablePdfFeatures !== false) {
            addAdditionalElements(options, leftPanelElements);
          } else {
            removeAdditionalElements(options, leftPanelElements);
          }
          webViewerElements = annotationsFeatureWebViewerElements.concat(freeTextToolElements, tickMarkToolElements);
          if (options.editable) {
            options.showTickMarkTools = true;
            options.showFreeTextTool = true;
            addAdditionalElements(options, webViewerElements);
            if (options.enablePdfFeatures) {
              options.showHighlightTool = true;
              addAdditionalElements(options, highlightToolElements);
            } else if (options.enablePdfFeatures === false) {
              options.showHighlightTool = false;
              removeAdditionalElements(options, highlightToolElements);
            }
          } else if (options.editable === false) {
            options.showTickMarkTools = false;
            options.showFreeTextTool = false;
            options.showHighlightTool = false;
            removeAdditionalElements(options, webViewerElements);
            removeAdditionalElements(options, highlightToolElements);
          }
          if (options.readonly) {
            options.showHighlightTool = false;
            options.showFreeTextTool = false;
            options.showTickMarkTools = false;
            removeAdditionalElements(options, [PdfTronElement.notePopupState]);
            removeAdditionalElements(options, freeTextToolElements);
            removeAdditionalElements(options, tickMarkToolElements);
            removeAdditionalElements(options, highlightToolElements);
          }
          if (options.enableViewControlAndMenu) {
            options.additionalPdfTronElements = ((_options$additionalPd2 = options.additionalPdfTronElements) !== null && _options$additionalPd2 !== void 0 ? _options$additionalPd2 : []).concat(cogMenu);
          }
          enableElements(webViewer, options);
          disableElements(webViewer);
          removeHeaderSeparatorItems(webViewer);
          if (options.showTickMarkTools) {
            addTickMarkTools(webViewer, CustomButton.TickMarkYellow, CustomButtonBase64PngImage.TickMarkYellowPng);
            addTickMarkTools(webViewer, CustomButton.TickMarkRed, CustomButtonBase64PngImage.TickMarkRedPng);
            addTickMarkTools(webViewer, CustomButton.TickMarkGreen, CustomButtonBase64PngImage.TickMarkGreenPng);
            addTickMarkTools(webViewer, CustomButton.TickMarkBlue, CustomButtonBase64PngImage.TickMarkBluePng);
          }
          if (options.showFreeTextTool) {
            addFreeTextGroupTool(webViewer);
          }
          if (options.showHighlightTool) {
            addHighlightGroupTool(webViewer);
          }
          if (options.readonly) {
            setReadOnly(webViewer, !!options.readonly);
            webViewer.UI.disableFeatures([PdfTronFeature.ThumbnailMerging, PdfTronFeature.ThumbnailReordering, PdfTronFeature.MultipleViewerMerging]);
            webViewer.UI.disableElements(thumbnailElements);
          }
          if (options.showHeader) {
            webViewer.UI.disableElements([PdfTronElement.printButton]);
          }
          if (options.disableEditingOutlines) {
            webViewer.UI.disableFeatures([PdfTronFeature.OutlineEditing]);
          }
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _configureWebViewer.apply(this, arguments);
}
export function resetViewerOptions(webViewer, options, hostElement) {
  if (options.readonly) {
    setReadOnly(webViewer, false);
    webViewer.UI.enableFeatures([PdfTronFeature.ThumbnailMerging, PdfTronFeature.ThumbnailReordering, PdfTronFeature.MultipleViewerMerging, PdfTronFeature.OutlineEditing]);
    webViewer.UI.enableElements(thumbnailElements);
  }
  if (options.additionalPdfTronElements) {
    webViewer.UI.disableElements(options.additionalPdfTronElements);
  }
  webViewer.UI.disableTools([CustomButton.TickMarkYellow, CustomButton.TickMarkRed, CustomButton.TickMarkGreen, CustomButton.TickMarkBlue]);
  if (!options.disableDefaultPdfTronElements) {
    webViewer.UI.disableElements(defaultPdfTronElements);
  }
  if (options.showHeader) {
    webViewer.UI.enableElements([PdfTronElement.printButton]);
  }
  removeAlerts(hostElement, AlertLocation.top);
  removeAlerts(hostElement, AlertLocation.bottom);
}
export function checkIfWatermarkIsSet(watermarkSettings) {
  return watermarkSettings && Object.keys(watermarkSettings).length > 0 && Object.keys(watermarkSettings).some(function (item) {
    var _watermarkSettings;
    return (_watermarkSettings = watermarkSettings[item]) === null || _watermarkSettings === void 0 ? void 0 : _watermarkSettings.text;
  });
}
export function downloadDocument(_x3, _x4) {
  return _downloadDocument.apply(this, arguments);
}
function _downloadDocument() {
  _downloadDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, container) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return DiContainer.instance.documentService.saveDocument(key, container);
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _downloadDocument.apply(this, arguments);
}
export function downloadDocumentFromViewer(_x5) {
  return _downloadDocumentFromViewer.apply(this, arguments);
}
function _downloadDocumentFromViewer() {
  _downloadDocumentFromViewer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(options) {
    var webViewer, key, container, documentMimeType, includeAnnotations, downloadAsPdf, password, newDocumentName, annotationManager, doc, isDocAnnotatable, watermark, exportFromViewer, annotations, xfdfString, fileData, docType, originalFileName, documentCopyFileName, documentCopyBlob, documentCopyUrl, documentCopy, _options, data, byteArray, blob, fileName;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          webViewer = options.webViewer, key = options.key, container = options.container, documentMimeType = options.documentMimeType, includeAnnotations = options.includeAnnotations, downloadAsPdf = options.downloadAsPdf, password = options.password, newDocumentName = options.newDocumentName;
          annotationManager = webViewer.Core.documentViewer.getAnnotationManager();
          doc = webViewer.Core.documentViewer.getDocument();
          isDocAnnotatable = Object.values(AnnotatableFileMimeType).includes(documentMimeType);
          _context4.next = 6;
          return webViewer.Core.documentViewer.getWatermark();
        case 6:
          watermark = _context4.sent;
          exportFromViewer = annotationManager && (isDocAnnotatable && includeAnnotations || downloadAsPdf || checkIfWatermarkIsSet(watermark));
          if (!exportFromViewer) {
            _context4.next = 38;
            break;
          }
          void webViewer.Core.documentViewer.setWatermark({});
          annotations = annotationManager.getAnnotationsList();
          _context4.next = 13;
          return annotationManager.exportAnnotations({
            annotList: includeAnnotations ? annotations : [],
            fields: true,
            widgets: true,
            links: true
          });
        case 13:
          xfdfString = _context4.sent;
          _context4.next = 16;
          return doc.getFileData();
        case 16:
          fileData = _context4.sent;
          void webViewer.Core.documentViewer.setWatermark(watermark);
          docType = doc.getType();
          originalFileName = newDocumentName !== null && newDocumentName !== void 0 ? newDocumentName : doc.getFilename();
          documentCopyFileName = originalFileName.endsWith('.pdf') || docType === 'office' ? originalFileName : "".concat(originalFileName, ".pdf");
          documentCopyBlob = new Blob([new Uint8Array(fileData)]);
          documentCopyUrl = URL.createObjectURL(documentCopyBlob);
          _context4.next = 25;
          return webViewer.Core.createDocument(documentCopyUrl, {
            filename: documentCopyFileName,
            loadAsPDF: true,
            password: password
          });
        case 25:
          documentCopy = _context4.sent;
          documentCopy.setWatermark(watermark);
          _options = {
            xfdfString: xfdfString
          };
          _context4.next = 30;
          return documentCopy.getFileData(_options);
        case 30:
          data = _context4.sent;
          byteArray = new Uint8Array(data);
          blob = new Blob([byteArray], {
            type: 'application/pdf'
          });
          fileName = originalFileName.endsWith('.pdf') ? originalFileName : "".concat(originalFileName, ".pdf");
          saveAs(blob, fileName);
          documentCopy.unloadResources();
          _context4.next = 40;
          break;
        case 38:
          _context4.next = 40;
          return downloadDocument(key, container);
        case 40:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _downloadDocumentFromViewer.apply(this, arguments);
}
export function configureDownloadButton(webViewer, options, downloadHandler) {
  if (options.additionalPdfTronElements.includes(PdfTronElement.downloadButton)) {
    var downloadButton = webViewer.UI.iframeWindow.document.querySelector("[data-element=\"".concat(PdfTronElement.downloadButton, "\"]"));
    if (!downloadButton) return;
    var customDownloadButton = downloadButton.cloneNode(true);
    var customDownloadButtonSpan = customDownloadButton.querySelector('span');
    if (customDownloadButtonSpan) {
      customDownloadButtonSpan.textContent = options.strings.downloadButton;
    }
    customDownloadButton.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            downloadHandler();
            if (!document.fullscreenElement) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return document.exitFullscreen();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    downloadButton.replaceWith(customDownloadButton);
  }
}
export function configurePrintDialog(webViewer) {
  var _webViewer$UI, _printQualitySelect$p;
  var body = webViewer === null || webViewer === void 0 || (_webViewer$UI = webViewer.UI) === null || _webViewer$UI === void 0 || (_webViewer$UI = _webViewer$UI.iframeWindow) === null || _webViewer$UI === void 0 ? void 0 : _webViewer$UI.document;
  var printQualitySelect = body === null || body === void 0 ? void 0 : body.querySelector('.printQualitySelect');
  printQualitySelect === null || printQualitySelect === void 0 || (_printQualitySelect$p = printQualitySelect.parentElement) === null || _printQualitySelect$p === void 0 || _printQualitySelect$p.remove();
  var printModalRadioButtons = body === null || body === void 0 ? void 0 : body.querySelectorAll('.ui__choice--radio');
  printModalRadioButtons === null || printModalRadioButtons === void 0 || printModalRadioButtons.forEach(function (b) {
    return b === null || b === void 0 ? void 0 : b.remove();
  });
}
export function configureFilterModal(webViewer) {
  var _webViewer$UI$iframeW, _colorButtons$parentE;
  var body = webViewer === null || webViewer === void 0 || (_webViewer$UI$iframeW = webViewer.UI.iframeWindow) === null || _webViewer$UI$iframeW === void 0 ? void 0 : _webViewer$UI$iframeW.document;
  var colorButtons = body === null || body === void 0 ? void 0 : body.querySelector('.color');
  colorButtons === null || colorButtons === void 0 || (_colorButtons$parentE = colorButtons.parentElement) === null || _colorButtons$parentE === void 0 || _colorButtons$parentE.remove();
}
export function addClosableAlert(location, type, message, hostElement) {
  var container = hostElement.querySelector(location);
  var alertElement = document.createElement('bm-alert');
  alertElement.setAttribute('type', type);
  alertElement.setAttribute('closeable', 'true');
  alertElement.innerText = message;
  alertElement.addEventListener('close', function () {
    container.removeChild(alertElement);
  });
  container.append(alertElement);
  return alertElement;
}
function getPrintWarningMessage(messageTemplate, documentName, percentage) {
  return messageTemplate.replace('{{DocumentName}}', documentName).replace('{{Percentage}}', percentage.toFixed(1));
}
export function printDocument(webViewer, options, printWarningMessageTemplate, hostElement) {
  var documentName = webViewer.Core.documentViewer.getDocument().getFilename();
  var printProgressBanner = addClosableAlert(AlertLocation.top, AlertType.warning, getPrintWarningMessage(printWarningMessageTemplate, documentName, 0), hostElement);
  var pageCount = webViewer.Core.documentViewer.getPageCount();
  var completedPageCount = 0;
  webViewer.UI.printInBackground(_objectSpread(_objectSpread({}, options), {}, {
    onProgress: function onProgress(_pageNumber, page) {
      if (printProgressBanner.parentNode && page.tagName.toLowerCase() === 'img') {
        completedPageCount++;
        var percentage = completedPageCount / pageCount * 100;
        printProgressBanner.innerText = getPrintWarningMessage(printWarningMessageTemplate, documentName, percentage);
        if (pageCount === completedPageCount) {
          void webViewer.Core.documentViewer.setWatermark({});
          printProgressBanner.parentNode.removeChild(printProgressBanner);
        }
      }
    }
  }));
}
export function handleKeyDown(event, handler) {
  var escCode = 'Escape';
  if (event.code === escCode) {
    event.preventDefault();
    event.stopImmediatePropagation();
    handler();
  }
}
function removeAlerts(hostElement, containerClass) {
  var container = hostElement.querySelector(containerClass);
  while (container !== null && container !== void 0 && container.hasChildNodes()) {
    container === null || container === void 0 || container.removeChild(container.firstChild);
  }
}
export function exportAnnotations(_x6, _x7) {
  return _exportAnnotations.apply(this, arguments);
}
function _exportAnnotations() {
  _exportAnnotations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(annotationManager, exportedAnnotations) {
    var annotations, _iterator, _step, annotation, image;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          annotations = exportedAnnotations !== null && exportedAnnotations !== void 0 ? exportedAnnotations : annotationManager.getAnnotationsList();
          _iterator = _createForOfIteratorHelper(annotations);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              annotation = _step.value;
              image = annotation.image;
              if (image) {
                image.width = image.naturalWidth;
                image.height = image.naturalHeight;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context5.abrupt("return", exportedAnnotations ? annotationManager.exportAnnotations({
            annotList: exportedAnnotations
          }) : annotationManager.exportAnnotations());
        case 4:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _exportAnnotations.apply(this, arguments);
}
export function removeDuplicates(a) {
  return a.filter(function (item, pos) {
    return a.indexOf(item) === pos;
  });
}
export function addAdditionalElements(options, elements) {
  options.additionalPdfTronElements = (options.additionalPdfTronElements || []).concat(elements);
  return removeDuplicates(options.additionalPdfTronElements);
}
export function removeAdditionalElements(options, elements) {
  options.additionalPdfTronElements = (options.additionalPdfTronElements || []).filter(function (item) {
    return !elements.includes(item);
  });
  return options.additionalPdfTronElements;
}
